runOnLoad "Campaigns", [ "confirm_send" ], ->

  maxDelay    = 1000
  delayLength = 25.0
  maxRetries  = 5
  retryCount  = 0
  campaignId  = $("#campaign_id").val()
  $recipients = $(".fill-in-recipients")
  $suppressed = $(".fill-in-suppressed-recipients")
  $countBtn   = $(".request-recipient-count")

  # We might be on a different template.
  return unless campaignId

  # Function to kick off the request to Studio for the count.
  getCount = (path) ->
    $.ajax
      dataType: "json"
      url:      path
      success:  loadRecipientCount
      error:    -> handleFailure(path, undefined)

  # We don't particularly want people to schedule campaigns with zero recipients.
  handleZeroRecipients = ->
    $("section.campaign-summary div.inline-notice")
      .after(
        $("<div class='inline-notice inline-error'></div>")
          .text(t "notices.campaign_zero_recipients")
      )

  # Handle the response that comes from the recipient count endpoint.
  loadRecipientCount = (data) ->
    # No data object? No way!
    if !data
      handleFailure(undefined, undefined)
    # The count is finished, display it.
    else if data["state"] == "finished"
      $recipients.text(data["recipient_count_string"])
      $suppressed.text(data["suppressed_count_string"])
      handleZeroRecipients() if data["recipient_count"] == 0
    # The count is still running, wait and re-poll.
    else if data["state"] == "waiting" && data["query_id"]
      path = Routes.calculate_recipients_campaign_path(campaignId, { query_id: data["query_id"] })
      delay(delayLength, -> getCount(path))
      delayLength = Math.min(delayLength * 1.5, maxDelay)
    # Handle failures.
    else
      handleFailure(undefined, data["error_message"])

  # Sometimes things fail. That's sad, but it doesn't have to be the end of the runtime.
  handleFailure = (retryPath, message) ->
    if retryPath && retryCount < maxRetries
      retryCount += 1
      getCount(retryPath)
    else
      if typeof(message) != "string" || !message
        message = t("notices.recipient_count_failed")
      $recipients.text(message)
      $suppressed.html("&mdash;")

  # The first query won't have a query_id associated with it. If a count button
  # was provided, don't start calculating until we click it. If there's no
  # button, start calculating immediately.
  kickoff = ->
    spinner       = new Image
    spinner.src   = require("@images/spinner.gif")
    $spinner      = $(spinner)
    $spinner.css("margin-top": "-2px", "margin-bottom": "-2px")
    $recipients.text(t("phrases.calculating_recipients"))
    $recipients.append("&nbsp;")
    $recipients.append($spinner)
    getCount(Routes.calculate_recipients_campaign_path(campaignId))
  if $countBtn.length > 0
    $countBtn.on "click", ->
      kickoff()
      return false
  else
    kickoff()



runOnLoad "Campaigns", [ "edit_schedule", "update", "confirm_send" ], ->
  SchedulableForm.setup "campaign_dispatch_attributes"



runOnLoad "Campaigns", [ "index" ], ->
  $(document).on "change", "select#filter_campaigns_by_mailing_list_id", ->
    $.getScript "?mailing_list_id=" + $(this).val()



runOnLoad "Campaigns", [ "edit_segmentation_criteria", "update" ], ->
  SegmentationBuilder.setup()



runOnLoad "Campaigns", [ "edit_content", "update" ], ->

  campaignId = parseInt($("#campaign_id").val(), 10)

  ### Setup Attachments ###

  $uploader    = $('#uploader')
  $attachments = $('#attachments')

  $attachments.on 'click', 'a', (event) ->
    event.preventDefault()
    $(@).closest('tr').removeClass('active').find('input.destroy').val(1)
    if $('tr.active', $attachments).length == 1
      $attachments.hide()
      $('.form-section-container.attachments').hide()

  filesize = (bytes, thresh=1024) ->
    return bytes + ' Bytes' if bytes < thresh

    units = ['KB','MB','GB','TB','PB','EB','ZB','YB']
    u     = -1

    loop
      bytes /= thresh
      ++u
      break unless bytes >= thresh

    return bytes.toFixed(1)+' '+units[u];

  $uploader.on 'change', (event) ->
    $uploader.parent().removeClass 'field_with_errors'
    $uploader.next().next().text ''

    file = FileAPI.getFiles(event)[0]

    if $('tr.active', $attachments).map(-> $(@).data('name')).toArray().indexOf(file.name) != -1
      $uploader.parent().addClass 'field_with_errors'
      $uploader.next().next().text t('activerecord.errors.messages.filename_in_use')
      $uploader.val('')
      return

    if file.size > parseInt($uploader.data 'file')
      $uploader.parent().addClass 'field_with_errors'
      $uploader.next().next().text t('activerecord.errors.messages.file_too_big', limit: filesize($uploader.data('file')))
      $uploader.val('')
      return

    if $uploader.data('campaign')
      total = file.size

      $('tr.active', $attachments).each ->
        total += parseInt $(@).data('size') if $(@).data('size')

      if total > parseInt($uploader.data 'campaign')
        $uploader.parent().addClass 'field_with_errors'
        $uploader.next().next().text t('activerecord.errors.messages.total_too_big', limit: filesize($uploader.data('campaign')))
        $uploader.val('')
        return

    FileAPI.upload
      url: Routes.attachments_path()
      files: { file: file }
      data: { authenticity_token: $('meta[name="csrf-token"]').attr('content') }

      progress: (event, file, xhr, options) ->
        percent = event.loaded/event.total * 100
        $uploader.attr('disabled', 'disabled').next().text(percent + '%')

      complete: (error, xhr) ->
        $uploader.removeAttr('disabled').next().text(t 'buttons.add_an_attachment')

        $attachments.show()
        $('.form-section-container.attachments').show()

        $attachments.append """
          <tr class='active' data-size='#{file.size}' data-name='#{file.name}'>
            <td>
              <input type='hidden' name='campaign[campaign_attachments_attributes][][attachment_id]' value='#{xhr.responseText}'>
              <input type='hidden' name='campaign[campaign_attachments_attributes][][attachment_name]' value='#{file.name}'>
              <input type='hidden' class='destroy' name='campaign[campaign_attachments_attributes][][_destroy]' value='#{file.name}'>
              #{file.name}
            </td>
            <td>
              #{filesize file.size}
            </td>
            <td>
              <a class='button action-button trash-button' href='#'>
                <i class='ir'></i>
              </a>
            </td>
          </tr>
        """

    $uploader.val('')

  $editors       = $('#content-editors')
  $tabs          = -> $('.tab:not(.add)')
  $removeVersion = $('.tab .remove')
  $addTab        = $('.tab.add')
  $addVersion    = $('#content-add-version')
  $addModal      = $('#campaign-add-version-modal')
  removals       = []

  # We don't seem to be on proper page
  return unless $editors.length > 0

  # Don't show the name field unless we're editing a campaign that uses split testing.
  adjustContentNameVisibility = -> $("li.campaign_content_name").toggle($('.ab-testing-off').is(":visible"))
  adjustContentNameVisibility()

  $('.ab-testing-on').click ->
    $('#content').addClass 'ab-testing'
    adjustContentNameVisibility()

  $('.ab-testing-off').click ->
    if $tabs().length > 1
      Dialogs.presentModal
        body: t('modal.campaign.clean_contents')
      return
    $('#content').removeClass 'ab-testing'
    adjustContentNameVisibility()

  # If we try to submit any of the individual content forms, stop that action
  # and instead click on the "Submit" button for the entire page.
  $(document).on "submit", "form.edit_campaign_content, form.new_campaign_content, form.edit_campaign", (event) ->
    return true if event.isActualSubmission

    event.preventDefault()
    event.stopPropagation()

    $form = $("form.edit_campaign")

    ContentEditor.finalizeAllEditors ->
      fieldsHtml = ""

      # For campaigns, we need to move data over into the submission form.
      # Look through each sub-form (individual contents) and collect the parameters into a single form.
      $("form.edit_campaign_content, form.new_campaign_content").each (i) ->
        $contentForm = $(@)

        for entry in $contentForm.serializeArray() when entry.name.substring(0, 16) == 'campaign_content'
          name  = encodeHtmlEntities("campaign[campaign_contents_attributes][]#{ entry.name.substring(16) }")
          value = encodeHtmlEntities(entry.value)

          fieldsHtml += """
            <input type='hidden' name='#{ name }' value='#{ value }'>"
          """

      # Make the form entries to delete old contents.
      for id in removals
        fieldsHtml += """
          <input type="hidden" name="campaign[campaign_contents_attributes][][id]" value="#{id}">
          <input type="hidden" name="campaign[campaign_contents_attributes][][_destroy]" value="1">
        """

      # Append the HTML into the form that'll be submitted.
      $("#content-inputs", $form).append(fieldsHtml)

      # Cause the form to actually submit.
      event = jQuery.Event("submit")
      event.isActualSubmission = true
      $form.trigger(event)

    # Prevent the form from actually being submitted.
    false

  versionOffset = ($selected) ->
    $options    = $tabs()
    $selected ||= $options.filter('.active')
    $options.index $selected

  showProperEditor = ->
    value = versionOffset()
    $area = $('.content_editor').hide().eq(value).show()
    UI.setupSelects $area

  showProperEditor()

  $('body').on 'click', '.tab:not(.add)', ->
    $tabs().removeClass('active')
    $(@).addClass('active')
    showProperEditor()
    return false

  $('body').on 'click', '.tab .remove', ->
    $tab    = $(@).closest('.tab')
    $editor = $('.content_editor').eq(versionOffset $tab)
    id      = $editor.data('id')

    $tabs().first().addClass('active') if $tab.is('.active')
    $editor.remove()
    $tab.remove()

    removals.push(id) if id
    showProperEditor()
    return false

  $addVersion.click ->
    $addModal.removeClass 'error'

    letter = String.fromCharCode(65 + $tabs().length)
    $("input.name", $addModal).val t('campaigns.labels.default_content') + ' ' + letter

    $content = $("select.duplicate-content-index", $addModal).html("")
    $content.append($("<option></option>").attr("value", "").text(t("blank_options.select_a_content_to_duplicate")))
    _.each $("#content-editors .content_editor"), (container, index) =>
      $container = $(container)
      name = $("input[name='campaign_content[name]']", $container).val()
      isEDM = $(".edm-tab-selector.active", $container).length == 1
      if !isEDM
        $content.append($("<option></option>").attr("value", index).text(name))
    $content.val("").trigger("change")

    $addModal.modal()
    return false

  $('input', $addModal).keydown (event) ->
    if event.keyCode == 13
      event.preventDefault()
      event.stopPropagation()
      $('button.primary', $addModal).click()

  $('button', $addModal).click ->
    $addModal.removeClass 'error'

    name               = $("input.name", $addModal).val()
    contentIndex       = parseInt($("select.duplicate-content-index", $addModal).val(), 10)
    $contentContainer  = if _.isNaN(contentIndex) then null else $($("#content-editors .content_editor").get(contentIndex))
    $button            = $(this)

    return if $button.is('.in-progress')

    if $button.is('.primary') && name.length > 0
      names = $tabs().find('a').map(-> $(@).text()).get()

      unless names.indexOf(name) == -1
        $addModal.addClass 'error'
        return false

      $button.addClass 'in-progress'

      $.post Routes.edit_content_editor_campaign_path(campaignId), { name: name }, (form) ->
        $form = $(form)
        $tabs().removeClass 'active'
        $addTab.before "<div class='tab active'><a href='#'>#{name}</a> <span class='remove'>x</span></div>"
        $editors.append($form)
        showProperEditor()

        # We have a content to duplicate; do it now.
        if $contentContainer
          $("input[name='campaign_content[content_attributes][subject]']", $form).val($("input[name='campaign_content[content_attributes][subject]']", $contentContainer).val())
          $("select[name='campaign_content[content_attributes][format]']", $form).val($("select[name='campaign_content[content_attributes][format]']", $contentContainer).val()).trigger("change")

          $oldHtmlEditor = $(".editor_subsection_html .editor-container", $contentContainer)
          $oldTextEditor = $(".editor_subsection_text .editor-container", $contentContainer)
          $newHtmlEditor = $(".editor_subsection_html .editor-container", $form)
          $newTextEditor = $(".editor_subsection_text .editor-container", $form)
          ContentEditor.setup($oldHtmlEditor).getContent((_, html) => ContentEditor.setup($newHtmlEditor).setContent(html))
          ContentEditor.setup($oldTextEditor).getContent((_, text) => ContentEditor.setup($newTextEditor).setContent(text))

        $button.removeClass 'in-progress'
        $addModal.modal('hide')
        ContentImporter.setup()
    else
      $addModal.modal('hide')



runOnLoad "Campaigns", [ "duplicate" ], ->

  $("#campaign_mailing_list_id").on "change", ->
    if $(this).val() == $("#original_mailing_list_id").val()
      $(".original-mailing-list-only").slideDown(100)
    else
      $(".original-mailing-list-only").slideUp(100)



runOnLoad "Campaigns", ["show"], ->

  campaignId = $("#campaign_id").val()
  campaignIsTemplate = $("#campaign_is_template").val() == "true"
  returnPath =
    if campaignIsTemplate
      Routes.template_path(campaignId) + "#template-summary"
    else
      Routes.campaign_path(campaignId) + "#campaign-summary"

  $("#campaign-summary-section").autoReload ->
    params =
      return_to: returnPath
      show_log_entries: $("#campaign-history-table").is(":visible")

    Routes.summary_campaign_path(campaignId, params)

  # Reload campaign statistics periodically.

  $campaignStatsSummary = $("#campaign-stats-section")

  $campaignStatsSummary.autoReload(Routes.stats_summary_campaign_path(campaignId))


runOnLoad "Campaigns", [ "new", "create" ], ->
  isTemplate = $("#campaign_template").val()
  UI.reloadFormOnChange Routes.new_campaign_path(template: isTemplate), ".form_essentials", [
    "#campaign_mailing_list_id"
    "#campaign_create_from_template_true"
    "#campaign_create_from_template_false"
    "#campaign_source_template_id"
  ]
